module.exports = __webpack_public_path__ + "img/信息系统运行维护能力叁级证书.2f5db2b2.png";